const bingMapsKey = require('../../config/bingMapKey');
module.exports = {
  developerEmail: 'unirac@unirac.com',
  apiUrl: 'dev2.design.unirac.com/',
  apiUrlUb1: 'legacy.design.unirac.com/',
  actionLogger: true,
  disableRaven: false,
  googleMapsKey: 'AIzaSyAKpYZTP0stvbFgs29p2PqWYVo8Laliiek',
  googleZipCodeKey: 'AIzaSyCHdPhyTFh15YrPCE9m5xfR9F4EpbmviJ8',
  bingMapsKey,
  googleAnalyticsTrackingId: 'UA-199955167-1',
  clarityProjectId: 'yuwr3xgeam',
  sentryLink: 'https://0ba0a7530e4a409f8e9e39b1290ee03e@o462086.ingest.sentry.io/5889168',
  cacheMemoizeTimeout: 30000,
  lruSize: 5,
  ssoLogoutUrl : 'https://dev.services.unirac.com/login?action=logout',
  ssoLoginUrl: 'https://dev.services.unirac.com/login?next=https://dev2.design.unirac.com/',
  ssoLoginUrlWithNext: 'https://dev.services.unirac.com/login?next=',
  applicationUrl: 'https://dev2.design.unirac.com',
  ssoLoginUrl: 'https://dev.services.unirac.com/login?next=https://dev2.design.unirac.com/',
  domainName: 'unirac.com',
  currentProjectVersion: '0.0.80',
};
